import { Chip, Tooltip } from "@mui/material";
import { useTheme, darken } from "@mui/material/styles";
import {
  IncidentStatus,
  statusColors,
} from "../../../data/FormColumns/Fleet/incidentsTableColumns";
import { parseDateUtcIfNoZone } from "../../../utils/timezone";
interface IncidentNote {
  id: string;
  note: string;
  date: string;
}

const IncidentStatusChip = ({
  value,
  notes,
}: {
  value: IncidentStatus;
  notes: IncidentNote[] | undefined;
}) => {
  const theme = useTheme();
  const hasNotes = Boolean(notes && notes.length);

  let baseColor;
  switch (statusColors[value].color) {
    case "primary":
      baseColor = theme.palette.primary.main;
      break;
    case "secondary":
      baseColor = theme.palette.secondary.main;
      break;
    case "error":
      baseColor = theme.palette.error.main;
      break;
    case "info":
      baseColor = theme.palette.info.main;
      break;
    case "success":
      baseColor = theme.palette.success.main;
      break;
    case "warning":
      baseColor = theme.palette.warning.main;
      break;
    default:
      baseColor = theme.palette.grey[500];
      break;
  }

  const chipStyle = {
    backgroundColor: hasNotes ? darken(baseColor, 0.3) : baseColor,
    color: "#fff",
  };

  const latestNote = notes
    ? [...notes].sort(
        (a, b) =>
          parseDateUtcIfNoZone(b.date).getTime() -
          parseDateUtcIfNoZone(a.date).getTime()
      )[0]
    : undefined;
  const tooltipText = latestNote ? latestNote.note : "";
  return (
    <Tooltip title={tooltipText}>
      <Chip label={statusColors[value].label} style={chipStyle} />
    </Tooltip>
  );
};

export default IncidentStatusChip;
